import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ccd5deba"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Picture: require('/vercel/path0/components/elements/Picture.vue').default,ModalContent: require('/vercel/path0/components/elements/Modal/ModalContent.vue').default,ModalContentSettingsPopup: require('/vercel/path0/components/elements/Modal/ModalContentSettingsPopup.vue').default})
